import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { SmartAuthWrapper } from '../components/SmartAuthWrapper';

/**
 * Unified authentication page that automatically detects and handles both
 * Telegram WebApp authentication and password-based authentication
 */
export function AuthPage() {
  const navigate = useNavigate();
  const { setError, updateUser } = useApp();

  const handleAuthSuccess = async (user: any) => {
    try {
      // For password authentication, we already have the user and token
      // Just update the app context directly
      updateUser(user);
      
      // Navigate to home page after successful authentication
      navigate('/');
    } catch (error) {
      console.error('Post-auth user update failed:', error);
      setError('Authentication completed but failed to load user data. Please try again.');
    }
  };

  const handleAuthError = (error: string) => {
    console.error('Authentication error:', error);
    setError(error);
  };

  return (
    <SmartAuthWrapper 
      onSuccess={handleAuthSuccess}
      onError={handleAuthError}
    />
  );
}